module.exports = __webpack_public_path__ + "img/ico-ar.b4fd224d.png";